import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { supabase } from "@/integrations/supabase/client";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
}

export function parseBrazilianCurrency(value: string): number | null {
  if (!value || value.trim() === '') return null;
  
  // Remove "R$", espaços e pontos de milhar
  const cleaned = value
    .replace(/R\$\s?/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? null : parsed;
}

export function formatBrazilianNumber(value: number | string): string {
  if (value === '' || value === null || value === undefined) return '';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '';
  return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Get Portal One company ID usando RPC function
 */
export async function getPortalOneCompanyId(): Promise<string | null> {
  try {
    const { data, error } = await supabase.rpc('get_portal_one_company_id');
    
    if (error) {
      console.error('Error getting Portal One company ID:', error);
      return null;
    }
    
    return data || null;
  } catch (error) {
    console.error('Unexpected error getting Portal One ID:', error);
    return null;
  }
}
